import { format } from "date-fns";
import { CheckSquare } from "react-bootstrap-icons";
import { cn } from "@utils";
import {
  itemAnchorDate,
  projectionIdentity,
  taskChipStyle,
  statusChipStyles,
  defaultChipStyle,
} from "@areas/calendar/common";

// A 28px-tall tile for the Today's-tasks schedule rail. Reuses the calendar's shared identities,
// status palette and glyphs (see EventChip) so the rail stays consistent with the calendar: promise
// Promise to Pay / indigo Payment Plan with their icons, slate tasks with the checkbox, and the
// STATUS chip for a plain event (orange when confirmed).
const ScheduleChip = ({ item, onClick }) => {
  // Tasks anchor on their due date, not a start — read the time from whichever the item has.
  const anchor = itemAnchorDate(item);
  const time = !item.allDay && anchor ? format(anchor, "HH:mm") : null;
  const identity = projectionIdentity(item);
  // A task takes the same neutral slate checkbox identity the calendar grid and activity feed give it.
  const isTask = !identity && item.kind === "task";

  const Icon = identity?.Icon ?? (isTask ? CheckSquare : null);
  const style = identity
    ? identity.panel
    : isTask && item.status !== "COMPLETED" && item.status !== "CANCELLED"
      ? taskChipStyle
      : statusChipStyles[item.status] ?? defaultChipStyle;

  if (identity) {
    const { label } = identity;
    const { reference, instalment, instalmentTotal } = item.projection ?? {};
    const position = instalment && instalmentTotal ? ` ${instalment}/${instalmentTotal}` : "";

    return (
      <button
        type="button"
        onClick={() => onClick?.(item)}
        className={cn(
          "flex h-7 w-full items-center gap-2 rounded-lg px-3 text-left text-xs transition-opacity hover:opacity-90",
          style,
        )}
      >
        {Icon && <Icon className="size-3.5 shrink-0" />}
        {time && <span className="shrink-0 font-semibold tabular-nums">{time}</span>}
        <span className="min-w-0 flex-1 truncate">
          <span className="font-semibold">
            {label}
            {position}
          </span>
          {reference && <span className="opacity-90"> · {reference}</span>}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => onClick?.(item)}
      className={cn(
        "flex h-7 w-full items-center gap-2 rounded-lg px-3 text-left text-xs transition-colors",
        style,
        isTask && "font-medium",
      )}
    >
      {Icon && <Icon className="size-3.5 shrink-0" />}
      {time && <span className="shrink-0 font-semibold tabular-nums">{time}</span>}
      <span className="min-w-0 flex-1 truncate">{item.summary || "(no title)"}</span>
    </button>
  );
};

export default ScheduleChip;
